import { BlogPostContent } from '@/types/blog';
import { introSection } from './sections/intro';
import { landkarteSection } from './sections/landkarte';
import { unterschiedeTabelle } from './sections/unterschiede-tabelle';
import { finanzcoachingSection } from './sections/finanzcoaching';
import { neurofinanceSection } from './sections/neurofinance';
import { ansatzSection } from './sections/ansatz';
import { rechtlicherHinweisSection } from './sections/rechtlicher-hinweis';
import { ctaCardsSection } from './sections/cta-cards';
import { quellenSection } from './sections/quellen';

export const content: BlogPostContent = {
  sections: [
    introSection,
    landkarteSection,
    unterschiedeTabelle,
    finanzcoachingSection,
    neurofinanceSection,
    ansatzSection,
    quellenSection,
    ctaCardsSection,
    rechtlicherHinweisSection
  ]
};
